module.exports = __webpack_public_path__ + "static/NOI5-cad89f6520c7dd9439753c1aa8eb4ab6.png";